import { format } from 'date-fns'

export function toUserTimezoneDateSelectorFormat(dateInput: Date, withTime?: boolean): string {
  return format(dateInput, `yyyy-MM-dd${withTime ? ' kk:mm' : ''}`)
}

export function toUtcIsoString(dateInput: string): string | undefined {
  const date = new Date(dateInput)
  return isNaN(date.getTime()) ? undefined : date.toISOString()
}
